export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover, interactive-widget=resizes-content"},{"name":"description","content":"La primera plataforma de IA legal nativa para LATAM hispanohablante. Revisión de contratos, investigación jurídica y redacción inteligente con contexto regional."},{"name":"theme-color","content":"#F8F8F8","media":"(prefers-color-scheme: light)"},{"name":"theme-color","content":"#111111","media":"(prefers-color-scheme: dark)"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Marcus"},{"property":"og:title","content":"Marcus - Legal Intelligence para Latinoamérica"},{"property":"og:description","content":"La primera plataforma de IA legal nativa para LATAM hispanohablante. Revisión de contratos, investigación jurídica y redacción inteligente con contexto regional."},{"property":"og:url","content":"https://holamarcus.com"},{"key":"og-image","property":"og:image","content":"https://holamarcus.com/og-image.png?v=3"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"property":"og:image:alt","content":"Marcus — Inteligencia legal construida para América Latina."},{"property":"og:locale","content":"es_LA"},{"property":"og:locale:alternate","content":"en_US"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Marcus - Legal Intelligence para Latinoamérica"},{"name":"twitter:description","content":"La primera plataforma de IA legal nativa para LATAM hispanohablante."},{"key":"twitter-image","name":"twitter:image","content":"https://holamarcus.com/og-image.png?v=3"}],"link":[{"rel":"canonical","href":"https://holamarcus.com"},{"rel":"alternate","hreflang":"es","href":"https://holamarcus.com"},{"rel":"alternate","hreflang":"en","href":"https://holamarcus.com?lang=en"},{"rel":"alternate","hreflang":"x-default","href":"https://holamarcus.com"},{"rel":"manifest","href":"/site.webmanifest"},{"key":"favicon-light","rel":"icon","type":"image/svg+xml","href":"/favicon.svg?v=6","media":"(prefers-color-scheme: light)"},{"key":"favicon-dark","rel":"icon","type":"image/svg+xml","href":"/favicon-dark.svg?v=6","media":"(prefers-color-scheme: dark)"},{"key":"favicon-ico","rel":"icon","href":"/favicon.ico?v=6","sizes":"any","media":"(prefers-color-scheme: light)"},{"rel":"apple-touch-icon","href":"/apple-touch-icon.png?v=3"},{"rel":"alternate","type":"application/json+oembed","href":"https://holamarcus.com/oembed.json","title":"Marcus"}],"style":[],"script":[{"innerHTML":"(function(){try{if(!window.location.pathname.startsWith('/app')&&!window.location.pathname.startsWith('/chat'))return;var p=localStorage.getItem('marcus_color_mode')||'system';var d=p==='system'?window.matchMedia('(prefers-color-scheme:dark)').matches:p==='dark';if(d)document.documentElement.classList.add('dark')}catch(e){}})()","type":"text/javascript"}],"noscript":[],"htmlAttrs":{"lang":"es"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const componentIslandsActive = false

export const payloadExtraction = true

export const prefetchPreloadTags = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true

export const clientNodePlaceholder = false

export const tracingChannelNuxt = false

export const runtimeCompiler = false

export const hasPluginDependencies = true

export const hasParallelPlugins = false

export const hasPluginHooks = true

export const hasIslandOptOutPlugins = false